import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "render"];
import React from 'react';
import PropTypes from 'prop-types';
import { FormSpy } from "./FormSpy";

/** Component that exposes `Form` values, error state, and actions that can be used to submit,
 * or reset the form, or even manipulate a single field. */
import { jsx as ___EmotionJSX } from "@emotion/core";
const FormActions = _ref => {
  let {
      children,
      render
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return ___EmotionJSX(FormSpy, props, children || render);
};
FormActions.propTypes = {
  /** A function that receives `fields`, `onUpdate`, `hasErrors`, `reset`, and `values` from
   * the `Form`. Will be ignored if render prop is passed */
  children: PropTypes.func,
  /** A function that receives `fields`, `onUpdate`, `hasErrors`, `reset`,
   *  and `values` from the `Form`. */
  render: PropTypes.func
};
export { FormActions };